<template>
  <v-container class="billing-view pl-0 pr-0" fill-height fluid>
    <v-layout fill-height fluid column space-between align-center>
      <BorderedTabs :settings="tabSettings"></BorderedTabs>
      <router-view :key="$route.path"></router-view>
    </v-layout>
  </v-container>
</template>

<script>
import BorderedTabs from '@/components/BorderedTabs'
import routes from '@/route_names'

export default {
  name: 'BillingView',
  mixins: [
    {
      computed: {
        routes: function() {
          return routes
        }
      }
    }
  ],
  components: {
    BorderedTabs
  },
  created: function() {},
  data: function() {
    return {
      route: this.$router.currentRoute.name,
      loading: true,
      tabSettings: {
        preselected: null,
        tabs: [
          {
            id: routes.ACCOUNTS_BILLING_CURRENT,
            label: 'Current Plan'
          },
          {
            id: routes.ACCOUNTS_BILLING_PLANS,
            label: 'Plans'
          },
          {
            id: routes.ACCOUNTS_BILLING_INVOICES,
            label: 'Payment History'
          }
        ]
      }
    }
  },
  methods: {
    save() {}
  }
}
</script>

<style lang="stylus">
</style>
